const HIDDEN_PROJECT_NAMES = ["head office", "registry"];

// Head Office and Registry are internal book-keeping "projects", not real
// projects — they shouldn't show up in Store module project dropdowns.
export const filterStoreProjects = (projects) =>
  (projects || []).filter(
    (p) => !HIDDEN_PROJECT_NAMES.includes((p?.ProjectName || "").trim().toLowerCase()),
  );
